export default "__VITE_ASSET__jAOElZW7__"